export const chartBLabels = Array.from({ length: 50 }, (_, i) => (i * 0.04).toFixed(2));

export const chartBOptions = {
  animation: {
    duration: 0,
  },
  legend: {
    display: false,
  },
  elements: {
    line: {
      tension: 0,
    },
  },
  maintainAspectRatio: false,
  spanGaps: false,
  steppedLine: "middle",
  scales: {
    xAxes: [
      {
        id: "x",
        scaleLabel: {
          display: false,
          labelString: "b (t)",
          fontStyle: "bold",
        },
      },
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          labelString: "h (t)",
          fontStyle: "bold",
        },
      },
    ],
  },
};

export const chartBAnnotations = {
  type: "line",
  display: true,
  scaleID: "x",
  value: 30,

  borderColor: "rgba(0, 0, 128, 1)",
  borderWidth: 3,
};
